var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollectPosLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 291.32 291.32",
    style: {
      enableBackground: "new 0 0 291.32 291.32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#450086;}\r\n\t.st2{fill:#732980;}\r\n\t.st3{fill:#20008A;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M201.52,8.13c-3.66-3.66-8.63-5.72-13.82-5.72H2.41V187.7c0,5.2,2.07,10.16,5.72,13.82l12.03,12.03V20.16 h193.39L201.52,8.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M241.39,48.01l-12.03-12.03c-0.18-0.18-0.33-0.33-0.5-0.45c-3.61-3.38-8.35-5.27-13.32-5.27H30.25v185.29 c0,4.89,1.84,9.58,5.14,13.17c0.15,0.23,0.38,0.45,0.58,0.66l12.03,12.03V234v-186h186H241.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M283.18,89.8l-11.2-11.2l-14.78-14.78c-0.35-0.35-0.71-0.68-1.06-0.98c-3.53-3.05-8.05-4.74-12.76-4.74h-9.33 H58.1v175.96v9.33c0,4.64,1.64,9.1,4.64,12.64c0.35,0.4,0.71,0.81,1.08,1.18l14.78,14.78h0l11.2,11.2 c3.68,3.66,8.65,5.73,13.82,5.73h185.29V103.59C288.91,98.42,286.84,93.45,283.18,89.8z M84,226.16c-0.71-0.71-1.08-1.64-1.08-2.62 V90.96c0-3.33,4.01-4.97,6.36-2.62l26.96,26.94c1.51,1.54,4.11,0.45,4.11-1.72V85.69c0-2.04,1.66-3.71,3.73-3.71h100.4 c0.98,0,1.92,0.38,2.62,1.08l35.23,35.23c0.71,0.71,1.11,1.66,1.11,2.65v32.16c0,1.56-0.98,2.92-2.37,3.46 c-0.43,0.18-0.88,0.28-1.36,0.28h-25.65h-4.34c-2.04,0-3.71-1.69-3.71-3.73v-29.99c0-2.04-1.66-3.71-3.73-3.71h-98.21 c-2.07,0-3.73,1.66-3.73,3.71v98.23c0,2.07,1.66,3.73,3.73,3.73h98.21c2.07,0,3.73-1.66,3.73-3.73v-24.72 c0-3.33,4.01-4.97,6.33-2.62l1.72,1.71l27.01,26.99l1.26,1.26c0.71,0.71,1.11,1.66,1.11,2.65v32.16c0,2.04-1.69,3.71-3.73,3.71 H121.88c-0.98,0-1.92-0.38-2.62-1.08l-0.33-0.33l-27.04-27.01L84,226.16z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectPosLogo);
export default __webpack_public_path__ + "static/media/collectPosLogo.b7f4c8918c375667a000e0114e968a4f.svg";
export { ForwardRef as ReactComponent };